import InputField from "../../applicationUi/components/intake/InputField";

const SiblingsSection = ({ formData, handleChange, isReadOnly = false }) => (
  <section className="space-y-6">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-foreground">Siblings</h2>
      <p className="text-sm text-muted-foreground">
        Please list any siblings, including their names and ages.
      </p>
    </div>
    <InputField
      label="Siblings (Names & Ages)"
      name="siblings"
      value={formData.siblings}
      onChange={handleChange}
      readOnly={isReadOnly}
      placeholder="e.g., Sarah (12), Michael (8)"
    />
  </section>
);

export default SiblingsSection;
